import { render, staticRenderFns } from "./AiIdeaFeedback.vue?vue&type=template&id=ece2608e&"
import script from "./AiIdeaFeedback.vue?vue&type=script&lang=js&"
export * from "./AiIdeaFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports